$(document).ready(function () {
    load_etc_info();

    activeTab(true);

    drawValueDirection();

    actionBuyNow();

    tablineCollapse();

    window.addEventListener('resize', () => {
        if (window.innerWidth) {
            activeTab();
        }
    })

    Window.composition.forEach(element => {
        renderComposition(element);
    });

    const select = new CustomSelect('.buy-now-broker-select');

    if ($('#ukPrivateModalExchanges').length) {
        $('#ukPrivateModalExchanges').modal('show');
    }
})

function load_etc_info() {
    $.getJSON(`/etc_info.json?date=${dateNum}`, update_etc_info);
}

function update_etc_performance(data, ticker) {
    if (!data) return;
    $.each(data, function (key, val) {
        $(`.js-${ticker}-` + key).text(val);
    });
    $(`.js-${ticker}-xetra`).attr('href', data.prodlink);
}

function update_etc_info(data) {
    window._etc_info = data;

    $('.js-create-date').text(data['create-date']);

    update_etc_performance(data.Bitcoin, 'btce');
    update_etc_performance(data.Litecoin, 'eltc');
    update_etc_performance(data.Ethereum, 'zeth');
    update_etc_performance(data.Bitcash, 'btch');
    update_etc_performance(data.Stellar, 'stlr');
    update_etc_performance(data.Tezos, 'extz');
    update_etc_performance(data.Polkadot, 'plka');
    update_etc_performance(data.Cardano, 'rdan');
    update_etc_performance(data.Solana, 'esol');
    update_etc_performance(data.Uniswap, 'uswa');
    update_etc_performance(data.Polygon, 'mtce');
    update_etc_performance(data.Cosmos, 'atme');
    update_etc_performance(data.Avalanche, 'eval');
    update_etc_performance(data.EthereumPOW, 'zetw');

    formatCur();
    formatToM(data);
}


function formatCur() {
    var formatText = document.querySelectorAll(".js-format-usd");
    formatText.forEach(t => {
        var val = t.innerText;
        t.innerText = usdFormat.format(parseFloatEx(val));
    })
}

function formatToM(data) {

    let formatElement = document.querySelectorAll('[data-formatm]');

    function formatter(setting, data) {
        let filter = setting.split(/\,/);

        let aum = data[`${filter[0]}`][`value-of-aum${filter[1]}`];
        aum = (parseInt(aum.replace(/(\$|,)/g, '')) / 1000000).toFixed(1);

        return aum + ' M';
    }

    if (formatElement) {
        formatElement.forEach(el => {
            let setting = el.dataset.formatm;
            el.innerText = formatter(setting, data);
        })
    }

}

const smoothScroll = (target, offset = 0, duration = 500) => {
    const start = window.pageYOffset;
    const to = target.getBoundingClientRect().top + window.pageYOffset - offset;
    const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

    const easeInOutCubic = function (t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    };

    function animation(currentTime) {
        const timeElapsed = currentTime - startTime;
        const nextStep = easeInOutCubic(timeElapsed / duration) * (to - start) + start;

        window.scrollTo(0, nextStep);

        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        } else {
            window.scrollTo(0, to);
        }
    }

    requestAnimationFrame(animation);
}


function activeTab(isInitialLoad) {
    const navLinks = $('.nav-link');

    navLinks.each(function () {
        $(this).on('click', function (event) {
            event.preventDefault();
            const hash = $(this).data('scrollspy-target');
            const targetSection = $(hash);
            smoothScroll(targetSection[0], 200, 500);
        });
    });

    let offsetTopTabs = $(window).width() < 991 ? 80 : 173;
    offsetTopTabs += 300; // add spacing between tabs and target

    const scrollSpy = function (isInitialLoad) {
        const sections = $('.scroll-spy-section');
        let currentSection = '';

        sections.each(function () {
            const sectionTop = $(this).offset().top;

            if ($(window).scrollTop() >= sectionTop - offsetTopTabs) {
                currentSection = $(this).attr('id');
            }
        });

        navLinks.each(function () {
            if (isInitialLoad) {
                const initialSection = sections.filter(function () {
                    const sectionTop = $(this).offset().top;
                    const sectionBottom = sectionTop + $(this).outerHeight();
                    return (
                        $(window).scrollTop() >= sectionTop - offsetTopTabs &&
                        $(window).scrollTop() < sectionBottom
                    );
                }).first();

                const sectionId = initialSection.length ? '#' + initialSection.attr('id') : '#' + sections.first().attr('id');

                if ($(this).data('scrollspy-target') !== sectionId && !isInitialLoad) {
                    $(this).removeClass('active');
                    return;
                }

                if ($(this).data('scrollspy-target') === sectionId) {
                    $(this).addClass('active');
                } else {
                    $(this).removeClass('active');
                }

                return;
            }

            console.log(currentSection);

            if ($(this).data('scrollspy-target') === '#' + currentSection) {
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                }
            } else {
                $(this).removeClass('active');
            }
        });
    };

    scrollSpy(isInitialLoad);

    $(window).on('scroll', function () {
        scrollSpy();
    });
}



$('.trading__copy-toggler').click(function () {
    const trigger = $(this).hasClass('active');

    $(this).toggleClass('active', !trigger);
    $(this).closest('.trading__tr').toggleClass('opened', !trigger);
})

function renderComposition(elem) {
    const chart = $(elem.target);

    function makeData(attr) {
        let makeArr = [];
        for (key in elem.data) {
            makeArr.push(elem.data[key][attr])
        }
        return makeArr;
    };

    const getOrCreateTooltip = (chart) => {
        let tooltipEl = chart.canvas.parentNode.querySelector('div');

        if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.classList.add('composition__tooltipwrapper')

            chart.canvas.parentNode.appendChild(tooltipEl);
        }

        return tooltipEl;
    };

    function externalTooltipHandler(context) {
        // Tooltip Element
        const { chart, tooltip } = context;
        const tooltipEl = getOrCreateTooltip(chart);
        const activeArg = arguments[0].tooltip._active[0];

        if (!activeArg) {
            tooltipEl.style.opacity = 0;
            return;
        }

        const tooltipData = elem.data[activeArg.index];

        if (tooltip.body) {
            tooltipEl.innerHTML = `
            <div class="composition__tooltip">
            <img src="/static/images/crypto-pins/${tooltipData['icon']}.svg" alt="logo">
            <span>${tooltipData['name']} ${tooltipData['percentage']}%</span>
            </div>
        `;
        }

        // Hide if no tooltip
        if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
        }

        const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

        let changeTooltipDirection = positionX + tooltip.caretX > chart.width * 0.5;

        tooltipEl.classList.toggle('reversed', changeTooltipDirection);

        tooltipEl.style.opacity = 1;
        tooltipEl.style.left = positionX + tooltip.caretX + 'px';
        tooltipEl.style.top = positionY + tooltip.caretY + 'px';
        tooltipEl.style.font = tooltip.options.bodyFont.string;
    }

    Chart.Tooltip.positioners.cursor = function (chartElements, coordinates) {
        return coordinates;
    };

    const composition = new Chart(chart, {
        type: 'doughnut',
        labels: ['one', 'two'],
        data: {
            datasets: [{
                label: makeData('icon'),
                data: makeData('percentage'),
                backgroundColor: makeData('color'),
            }],
        },
        options: {
            maintainAspectRatio: true,
            responsive: true,
            cutout: '55%',
            borderWidth: 0,
            onHover: (event, chartElement) => {
                if (chartElement.length === 1) event.native.target.style.cursor = 'none';
                if (chartElement.length === 0) event.native.target.style.cursor = 'default';
            },
            plugins: {
                tooltip: {
                    enabled: false,
                    position: 'cursor',
                    external: externalTooltipHandler,
                }
            }
        },
    });
}

function viewComponents(elem) {
    const target = $(elem).attr('data-target');
    const moreComponents = $(`${target} .more-components`);
    const btnText = $(elem).attr('data-btntext').split(',');
    const spanName = $(elem).find('span:first-child');
    const spanIcon = $(elem).find('span:last-child');

    if ($(moreComponents).is('.d-none')) {
        $(moreComponents).removeClass('d-none');
        $(spanName).html(btnText[1]);
        $(spanIcon).removeClass('my-chevron-down').addClass('my-chevron-up');
    } else {
        $(moreComponents).addClass('d-none');
        $(spanName).html(btnText[0]);
        $(spanIcon).removeClass('my-chevron-up').addClass('my-chevron-down');
    }
}

$('[data-toggler=wrap] button').click(function (e) {
    const target = $(this).attr('data-target');

    $(`button[data-target="${target}"]`).parent().find('button').removeClass('active');
    $(`button[data-target="${target}"]`).addClass('active');

    $(target).parent().find('[data-toggler="tab"]').removeClass('show active');
    $(target).addClass('show active');
})

const actionBuyNow = () => {
    let isReturningToSecondScreen = true;

    let brokerCheckboxes;
    const backDrop = document.getElementById('backdrop-buy-now');
    const brokerModal = document.getElementById('buy-now-broker');
    const brokerHeader = document.getElementById('buy-now-broker-header');
    const brokerContentScroll = document.getElementById('buy-now-broker-scroll');
    const btnOpenBroker = document.querySelectorAll('[data-open-modal-buy-now]');
    const btnContinueBroker = document.getElementById('buy-now-broker-continue');
    const btnsBackBroker = brokerModal.querySelectorAll('[buy-now-broker-back]');
    const btnCloseBrokerModal = document.querySelectorAll('[data-buy-now-broker-close]');
    const checkboxDisclaimer = document.getElementById('buy-now-broker-checkbox');
    const mainContent = document.getElementById('buy-now-broker-main-content');
    const brokerList = document.getElementById('buy-now-broker-list');
    const selectBrokersCountry = brokerModal.querySelector('.buy-now-broker__select');
    const listOption = selectBrokersCountry.querySelector('.select-options');
    const dataSelectCountryElement = selectBrokersCountry.querySelector('[data-selected-option-value]');
    const dataSelectedCountry = dataSelectCountryElement.dataset.selectedOptionValue;
    const dataBrokers = JSON.parse(brokerModal.dataset.brokers);
    const secondContent = document.getElementById('buy-now-broker-second-content');

    const brokerItem = (name, logo, homepage_url, product_page_url, checked = '') => {
        let url = homepage_url;
        const nameProduct = brokerList.dataset.fundKey;

        if (product_page_url) {
            url = product_page_url[nameProduct];
        }

        return `<label for="${name}" class="card card_picture card_picture--light card_picture--min-height card_picture--radio">
                <input type="radio" id="${name}" value="${url}" name="broker" ${checked}>
                <img src="${logo}" alt="${name}">
            </label>`;
    };

    if (backDrop && brokerModal && btnOpenBroker.length > 0) {

        const renderBrokers = (selectedValue) => {
            const valueCountry = () => {
            if (selectedValue === 'other' || selectedValue === 'us' || selectedValue === 'ca') {
                return 'ie';
            } else {
                return selectedValue;
            }
        };

            const currentSelectedCountryBrokers = dataBrokers[valueCountry()];
            const compareBrokers = (a, b) => {
                const aOrder = parseInt(a.order);
                const bOrder = parseInt(b.order);

                if (aOrder < bOrder) return -1;
                if (aOrder > bOrder) return 1;

                return a.name.localeCompare(b.name);
            }
            const sortCurrentSelectedCountryBrokers = currentSelectedCountryBrokers.sort(compareBrokers);

            sortCurrentSelectedCountryBrokers.forEach((country, index) => {
                let logo = country.img.framed.light || '';
                brokerList.insertAdjacentHTML('beforeend', brokerItem(country.name, logo, country.homepage_url, country.product_page_url, index === 0 ? 'checked' : ''));
            })

            brokerCheckboxes = mainContent.querySelectorAll('.card input[type="radio"]');
        };

        renderBrokers(dataSelectedCountry);

        const checkChangedAttributes = function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-selected-option-value') {
                    const newValue = mutation.target.dataset.selectedOptionValue;

                    updateBrokerList(newValue);
                }
            }
        };

        // следим за изменениями атрибута в кастомоном селекте
        const observer = new MutationObserver(checkChangedAttributes);
        observer.observe(dataSelectCountryElement, { attributes: true });

        const updateBrokerList = (selectedValue) => {
            brokerList.textContent = '';

            const uk_priv_trigger = selectedValue !== 'gb';
            if (uk_priv_trigger) $('#ukPrivateModalExchanges').modal('show');
            
            renderBrokers(selectedValue);
        };

        const closeModalBroker = () => {
            backDrop.classList.remove('backdrop--active');
            brokerModal.classList.remove('buy-now-broker--active');
            backActions();
        };

        const backActions = () => {
            isReturningToSecondScreen = true;
            btnContinueBroker.disabled = false;
            btnContinueBroker.dataset.buyNowBrokerLink = '';

            brokerHeader.classList.remove('buy-now-broker__header--continue');
            mainContent.classList.remove('d-none');
            secondContent.classList.add('d-none');
            btnsBackBroker.forEach((btn) => {
                btn.classList.add('d-none');
            });
        };

        for (const btn of btnOpenBroker) {
            btn.addEventListener('click', () => {
                backDrop.classList.add('backdrop--active');
                brokerModal.classList.add('buy-now-broker--active');
            });
        }

        for (const btn of btnCloseBrokerModal) {
            btn.addEventListener('click', closeModalBroker);
        }

        btnContinueBroker.addEventListener('click', () => {
            const isCheckedDisclaimer = checkboxDisclaimer.checked;

            btnContinueBroker.disabled = !isCheckedDisclaimer;

            btnsBackBroker.forEach((btn) => {
                btn.classList.remove('d-none');
            });
            brokerHeader.classList.add('buy-now-broker__header--continue');
            mainContent.classList.add('d-none');
            secondContent.classList.remove('d-none');

            brokerCheckboxes.forEach((checkbox) => {
                if (checkbox.checked) {
                    btnContinueBroker.dataset.buyNowBrokerLink = checkbox.value;
                }
            });

            if (isReturningToSecondScreen) {
                isReturningToSecondScreen = false;
            } else {
                isCheckedDisclaimer && window.open(btnContinueBroker.dataset.buyNowBrokerLink, '_blank');
            }
        });

        btnsBackBroker.forEach((btn) => {
            btn.addEventListener('click', backActions);
        });

        brokerCheckboxes.forEach((checkbox, index) => {
            if (index === 0) {
                checkbox.checked = true;
            }

            if (checkbox.checked && btnContinueBroker.dataset.buyNowBrokerLink === '') {
                btnContinueBroker.dataset.buyNowBrokerLink = checkbox.value;
            }
        });

        checkboxDisclaimer.addEventListener('change', () => {
            btnContinueBroker.disabled = !checkboxDisclaimer.checked;
        })
    }
};

function tablineCollapse() {
    document.querySelectorAll('[data-tabline-collapse]').forEach(c => {
        c.onclick = () => {
            const icon = c.querySelector('.my-icon');

            icon.classList.toggle('my-chevron-down');
            icon.classList.toggle('my-chevron-up');
        }
    })
}